import { render, staticRenderFns } from "./EditRecruitmentTypePopup.vue?vue&type=template&id=1463c239"
import script from "./EditRecruitmentTypePopup.vue?vue&type=script&lang=js"
export * from "./EditRecruitmentTypePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports